var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivePromptManager({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3821 13.9807H13.0343",
    stroke: "#1553CC",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3821 16.7346L9.78439 16.73",
    stroke: "#1553CC",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.635 7.18296C14.144 7.26854 14.144 7.97706 14.635 8.06124C15.5069 8.21345 16.3139 8.62155 16.9532 9.23364C17.5925 9.84574 18.0353 10.6341 18.2253 11.4986L18.2548 11.6347C18.3614 12.1215 19.0531 12.1244 19.1639 11.6389L19.2004 11.4804C19.3965 10.6193 19.8429 9.83539 20.4836 9.22748C21.1242 8.61956 21.9303 8.21476 22.8005 8.06404C23.2944 7.97706 23.2944 7.26714 22.8005 7.18155C21.9302 7.03074 21.1239 6.62573 20.4832 6.01755C19.8426 5.40936 19.3962 4.6252 19.2004 3.76382L19.1653 3.60669C19.0531 3.11984 18.3614 3.12405 18.2534 3.6109L18.2253 3.74559C18.0353 4.61004 17.5925 5.39846 16.9532 6.01055C16.3139 6.62264 15.5069 7.03074 14.635 7.18296Z",
    fill: "#1553CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5952 6.72656H4.68876C4.31665 6.72656 3.95979 6.87438 3.69668 7.13749C3.43356 7.40061 3.28575 7.75747 3.28575 8.12957V19.3536C3.28575 19.7257 3.43356 20.0826 3.69668 20.3457C3.95979 20.6088 4.31665 20.7566 4.68876 20.7566H17.3158C17.6879 20.7566 18.0448 20.6088 18.3079 20.3457C18.571 20.0826 18.7188 19.7257 18.7188 19.3536V13.7416M3.28575 10.2341L9.74442 10.2341",
    stroke: "#1553CC",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePromptManager);
export default __webpack_public_path__ + "static/media/active-prompt-manager.5040c2b86ddf6f438ec21f710c7fab12.svg";
export { ForwardRef as ReactComponent };